import React from 'react';
import PropTypes from "prop-types";
import { EuiSpacer } from '../../../../../src/components/spacer';
import { EuiTitle } from '../../../../../src/components/title';
import { EuiText } from '../../../../../src/components/text';
export var LANGUAGES = ['javascript', 'html'];
export var GuideSectionExampleText = ({
  title,
  children,
  wrapText = true
}) => {
  let titleNode;

  if (title) {
    titleNode = <>
        <EuiSpacer />
        <EuiTitle>
          <h2>{title}</h2>
        </EuiTitle>
        <EuiSpacer size="m" />
      </>;
  }

  let textNode = children;

  if (children && wrapText) {
    textNode = <EuiText>{children}</EuiText>;
  }

  return <>
      {titleNode}
      {textNode}
      {(titleNode || textNode) && <EuiSpacer />}
    </>;
};
GuideSectionExampleText.propTypes = {
  title: PropTypes.node,
  children: PropTypes.node,
  wrapText: PropTypes.bool
};

try {
  GuideSectionExampleText.__docgenInfo = {
    description: '',
    displayName: 'GuideSectionExampleText',
    methods: [],
    props: {
      title: {
        defaultValue: null,
        description: '',
        name: 'title',
        parent: undefined,
        required: false,
        type: {
          name: 'ReactNode'
        }
      },
      wrapText: {
        defaultValue: {
          value: 'true'
        },
        description: '',
        name: 'wrapText',
        parent: undefined,
        required: false,
        type: {
          name: 'boolean'
        }
      }
    },
    extendedInterfaces: []
  };
} catch (e) {}